module.exports = __webpack_public_path__ + "img/more-section-back.9b0907d9.png";